import React from 'react';
import { isNotDefined, breakFormat, _cs, isTruthyString, populateFormat } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function DateOutput(props) {
  var _formattedValueList$m;

  const {
    value,
    format = 'dd MMM, yyyy',
    className,
    emptyComponent = '-',
    tooltip,
    formatter = populateFormat
  } = props;
  const formattedValueList = React.useMemo(() => {
    if (isNotDefined(value)) {
      return undefined;
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return undefined;
    }

    return formatter(breakFormat(format), date);
  }, [format, value, formatter]);
  const formattedDate = formattedValueList === null || formattedValueList === void 0 ? void 0 : (_formattedValueList$m = formattedValueList.map(v => v.value)) === null || _formattedValueList$m === void 0 ? void 0 : _formattedValueList$m.join('');
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.dateOutput, className),
    title: tooltip ?? undefined
  }, isTruthyString(formattedDate) ? formattedDate : emptyComponent);
}

var DateOutput$1 = genericMemo(DateOutput);

export { DateOutput$1 as default };
//# sourceMappingURL=index.js.map
